import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-sam-navy text-sam-cream/80 mt-20">
      <div className="sam-flag-bar h-1 w-full" />
      <div className="mx-auto max-w-7xl px-6 py-12 grid gap-8 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="font-display font-extrabold text-sam-cream text-lg">SAVING AMERICA MONEY</div>
          <p className="mt-3 text-sm max-w-sm leading-relaxed">
            Connecting hometown local businesses with everyday savings, through our directory and the premium 9×12 postcard mailer reaching 10,000 homes per route.
          </p>
          <p className="mt-4 text-sm">
            <a href="tel:+18085592600" className="font-semibold text-sam-cream hover:text-white" data-testid="footer-phone">Call or text: (808) 559-2600</a>
          </p>
        </div>
        <div>
          <div className="font-display font-bold text-sam-cream mb-3 text-sm uppercase tracking-wider">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-white">About Us</Link></li>
            <li><Link to="/careers" className="hover:text-white font-semibold text-sam-amber" data-testid="footer-careers">Careers — Join the Team</Link></li>
            <li><Link to="/terms" className="hover:text-white" data-testid="footer-terms">Terms of Service</Link></li>
            <li><Link to="/blog" className="hover:text-white" data-testid="footer-blog">Blog</Link></li>
            <li><Link to="/podcast" className="hover:text-white" data-testid="footer-podcast">Podcast</Link></li>
            <li><Link to="/browse" className="hover:text-white">Browse Businesses</Link></li>
            <li><Link to="/postcards" className="hover:text-white">Postcard Mailers</Link></li>
            <li><Link to="/browse?parent=restaurants" className="hover:text-white">Dining</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-display font-bold text-sam-cream mb-3 text-sm uppercase tracking-wider">For Businesses</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/dashboard" className="hover:text-white">List Your Business</Link></li>
            <li><Link to="/postcards" className="hover:text-white">Advertise on a Postcard</Link></li>
            <li><Link to="/grow-my-business" className="hover:text-white">More Leads &amp; Sales</Link></li>
            <li><Link to="/hvac" className="hover:text-white">HVAC Companies</Link></li>
            <li><Link to="/plumbers" className="hover:text-white">Plumbers</Link></li>
            <li><Link to="/roofers" className="hover:text-white">Roofers</Link></li>
            <li><Link to="/electricians" className="hover:text-white">Electricians</Link></li>
            <li><Link to="/landscapers" className="hover:text-white">Landscapers</Link></li>
            <li><Link to="/painters" className="hover:text-white">Painters</Link></li>
            <li><Link to="/garage-door" className="hover:text-white">Garage Door</Link></li>
            <li><Link to="/pest-control" className="hover:text-white">Pest Control</Link></li>
            <li><Link to="/buy-a-home" className="hover:text-white">Buy a Home</Link></li>
            <li><Link to="/sell-your-home" className="hover:text-white">Sell Your Home</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-sam-cream/50">
        © {new Date().getFullYear()} Saving America Money. Proudly local.
      </div>
    </footer>
  );
}
